<template src="./template.html"></template>
<style lang="scss" scoped src="./style.scss"></style>
<script>
export default {
    name: 'ak-page-list',
    props: {
        title: {
            type: String,
            default: ''
        },
        backAction: {
            type: Function
        }
    },
    methods: {
        back() {
            return this.backAction ? this.backAction() : this.$router.back();
        }
    }
};
</script>
